import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:5005',
});

async function identificarBiometria(cancelToken) {
  const response = await api.post('/api/biometria/identificar', {}, { timeout: 20000, cancelToken });
  return response.data;
}

export {
  identificarBiometria
};
